import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const NewDocument = styled(Grid)({
  "& > .MuiFormControl-root": {
    margin: "20px 0",
  },
});

export const SaveButton = styled(Grid)({
  display: "flex",
  justifyContent: "flex-end",
  margin: "15px 0",
});

export const ConfirmBlock = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  gap: "30px",
});
